export const modifyCategoriesFilter = (data, listKey) => {
  if (!data) {
    return;
  }
  const newDataWithValueName = [];
  data.forEach((item) => {
    newDataWithValueName.push({
      id: item.id,
      valueClass: 0,
      valueKey: item.id,
      valueCaption: item.value,
      name: item.value,
      keyName: listKey?.[0] + item.id.toString().replace(/\s+/g, ''),
    });
  });
  return newDataWithValueName;
};
